import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import './index.css'
import { Providers } from './providers/query-provider.tsx'
import { UserProvider } from './providers/user-provider.tsx'
import { initPostHog } from './analytics/posthog.ts'

// Initialize PostHog analytics (no-op if VITE_POSTHOG_KEY is not set)
initPostHog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
        <UserProvider>
          <App />
        </UserProvider>
    </Providers>
  </React.StrictMode>,
)
